import { useNavigate } from "react-router-dom";
import { LoginResponse } from "./api/auth";

// Función standalone para guardar datos de login (sin hooks)
export const saveLoginData = (userData: LoginResponse) => {
  localStorage.setItem("isLoggedIn", "true");
  localStorage.setItem("token", userData.token);
  localStorage.setItem("user", JSON.stringify({
    id: userData.id,
    username: userData.username,
    nombre: userData.nombre,
    mail: userData.mail,
    rol: userData.rol,
    porcentaje: userData.porcentaje,
  }));
  // Guardar el NOMBRE (no username) para mostrar como vendedor en observaciones
  localStorage.setItem("current_username", userData.nombre);
};

// Función standalone para limpiar datos de sesión
export const clearLoginData = () => {
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("current_username");
};

const useAuth = () => {
  const navigate = useNavigate();

  const login = (userData: LoginResponse) => {
    saveLoginData(userData);
    navigate("/");
  };

  const logout = () => {
    clearLoginData();
    navigate("/login");
  };

  const getToken = (): string | null => {
    return localStorage.getItem("token");
  };

  const getUser = () => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  };

  const isAuthenticated = (): boolean => {
    return localStorage.getItem("isLoggedIn") === "true" && !!getToken();
  };

  return { login, logout, getToken, getUser, isAuthenticated };
};

export default useAuth;